import { useMemo } from 'react';
import { useFilterQueryContext } from 'src/contexts/FilterQueryContext';
import { UIReportV2PurchaseOrderLineItemQuery } from 'src/WebApiController';

import { FilterToolbarItemId } from '../Filters';
import { usePurchaseInfoFilters } from './usePurchaseInfoFilters';

export const purchaseOrderLineItemMandatoryFiltersToShow: FilterToolbarItemId[] =
  ['purchaseDates'];

const PurchaseInfoFilterIdsToShow = [
  'purchaseVendorId',
  'purchaseVendorAccountIds',
  'purchaseBuyerId',
  'purchaseDates',
  'purchaseVendorOrderId',
  'purchaseCancellationDates',
];

export function usePurchaseOrderLineItemReportFilters({
  isHorizontalLayout,
}: {
  isHorizontalLayout?: boolean;
}) {
  const { tempQuery, setTempQuery } =
    useFilterQueryContext<UIReportV2PurchaseOrderLineItemQuery>();

  const purchaseInfoFilters = usePurchaseInfoFilters({
    query: tempQuery,
    setQuery: setTempQuery,
    showCancellationDateFilter: true,
  });

  const supportedPurchaseInfoFilters = useMemo(() => {
    const items = purchaseInfoFilters.items.filter((item) =>
      PurchaseInfoFilterIdsToShow.includes(item.filterId)
    );

    return {
      ...purchaseInfoFilters,
      items,
    };
  }, [purchaseInfoFilters]);

  return {
    filters: [supportedPurchaseInfoFilters],
  };
}
